import React, { useMemo, Profiler } from 'react';
import Card from 'Components/Card/Card';
import styles from 'assets/css/CardBoard.module.css';
import LoadingHandler from 'Components/LoadingWrapper';
import { IconAngleDownBold } from '@ace/react-icons';
import onRenderCallback from 'tracking/onRenderCallback';
import PackeryHandler, { packeryDefaults } from 'Components/PackeryHandler';
//import useCardDisplayState, { CardCenterContextProvider, useCardToggle } from 'context/CardCenterContext';
import useComponentDisplayState, { ComponentToggleContextProvider, useComponentToggle } from 'context/ComponentToggleContext';
import getCardItemProps from 'Components/Card/helper/getCardItemProps';
import withPackeryCard from 'Components/Card/hoc/withPackeryCard';
import classNames from 'classnames';

export default function CardCenter (props) {
    const { type, retrievalUrl, componentName } = props;

    return (
        <main className="app-main" id={type}>
            <section className="app-main__inner">

                <Profiler id="CardCenter" onRender={onRenderCallback}>
                    {useMemo(() => (
                        <LoadingHandler retrievalUrl={retrievalUrl} componentName={componentName}>
                            {(data) => (<CardBoardsContainer data={data} componentName={componentName} />)}
                        </LoadingHandler>
                    ), [retrievalUrl, componentName])}
                </Profiler>

            </section>
        </main>
    );
}

const PackeryCard = withPackeryCard(Card);

const DraggableCards = (props) => {
    const { data, componentName } = props;

    const handlerProps = {
        ...packeryDefaults,
        className: styles.AdditionalCards,
        storageKey: "DraggableCards",
        childrenLength: data.AdditionalCards.length,
        componentName: componentName
    };

    if (!data.AdditionalCards.length)
        return false;

    return (
        <PackeryHandler {...handlerProps}>
            {data.AdditionalCards.map(card => {
                const cardProps = getCardItemProps(card);
                return (<PackeryCard {...cardProps} key={cardProps.componentName} />);
            })}
        </PackeryHandler>
    );
};

const CardBoardsContainer = (props) => {
    const { data, componentName } = props;

    const MainCards = useMemo(() => (
        <div className={styles.MainCards}>
            {data.MainCards.map(card => {
                const cardProps = getCardItemProps(card);
                return (<Card {...cardProps} key={cardProps.componentName} />)
            })}
        </div>
    ), [data.MainCards]);

    return (
        <Profiler id="CardBoardsContainer" onRender={onRenderCallback}>
            <ComponentToggleContextProvider componentName={componentName}>
                <ToggleAllCardsContainer />
                {MainCards}
                <DraggableCards {...props} />
            </ComponentToggleContextProvider>
        </Profiler>
    );
}

const ToggleAllCardsContainer = () => {
    const isCardShown = useComponentDisplayState('isAllShown');
    const classes = classNames({
        [`${styles.btnCardToggleRotate}`]: isCardShown
    });

    return (
        <div className={classes}>
            {useMemo(() => (<ToggleAllCards />), [])}
        </div>
    );
}

const ToggleAllCards = () => {
    const { toggleAll } = useComponentToggle();

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a className={styles.btnCardToggle} onClick={() => { toggleAll(); }}>
            <ToggleAllCardsInternal />
            <IconAngleDownBold className={styles.btnCardToggleIcon} />
        </a>
    )

}

const ToggleAllCardsInternal = () => {
    const isCardShown = useComponentDisplayState('isAllShown');

    return (
        <>
            {isCardShown ? "Close All" : "Open All"}
        </>
    );
}
